import PricingBanner from './PricingBanner';
// import PricingBox from './PricingBox';
import TestimonialSection from '../Home/TestimonialSection';
import BrokerageCalculator from './BrokerageCalculator';   
import FixedBrokerage from './FixedBrokerage'; 

function About() {
  return (
    <div className='about-section-main-box' style={{ overflowX: 'hidden', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
      <PricingBanner />
     {/* <BrokerageCalculator /> */}
     <FixedBrokerage/>
      <TestimonialSection />
      {/* <PricingBox /> */}
      
    </div>
  );
}

export default About;